module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "part",
      "id": "pt01pre"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p3"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0005#rpt01pre"
    }
  }, [_c('span', {
    staticClass: "symb"
  }, [_vm._v("•")]), _vm._v(" Preliminary "), _c('span', {
    staticClass: "symb"
  }, [_vm._v("•")])])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("The Objectivity of Willing")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epf"
  }, [_vm._v("Will making itself its own object is the basis of all Right and Obligation."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn89",
      "id": "fn89r"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Let us begin with this paragraph from the introduction to the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(":")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('i', [_vm._v("Right")]), _vm._v(" is any existence ["), _c('i', [_vm._v("Dasein")]), _vm._v("] in general which is the "), _c('i', [_vm._v("existence")]), _vm._v(" of the "), _c('i', [_vm._v("free will")]), _vm._v(". Right is therefore in general freedom, as Idea."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn90",
      "id": "fn90r"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The first thing to take from this passage—to which we could add a parallel paragraph from the "), _c('i', [_vm._v("Encyclopedia")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn91",
      "id": "fn91r"
    }
  }, [_vm._v("3")]), _vm._v("—is that there is a strong equivalence between "), _c('i', [_vm._v("freedom")]), _vm._v(", "), _c('i', [_vm._v("will")]), _vm._v(", and "), _c('i', [_vm._v("right")]), _vm._v(". This equivalence makes it possible to define the position of what Hegel calls "), _c('i', [_vm._v("objective spirit")]), _vm._v(". But what exactly do these concepts cover? In particular, what does the conjunction of will and right signify? This is what we must specify. One thing, however, is clear from the outset: within "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p4"
    }
  }), _vm._v("Hegelian philosophy the content of such concepts is different from their usual understanding, so it would be hasty, to say the least, to classify Hegel as a legal voluntarist, as sometimes has been done, on the grounds that he defines right as “the "), _c('i', [_vm._v("existence")]), _vm._v(" of the "), _c('i', [_vm._v("free will")]), _vm._v(".” There are several indications of this. First of all, following Kant—at least Kant of the "), _c('i', [_vm._v("Doctrine of Right")]), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn92",
      "id": "fn92r"
    }
  }, [_vm._v("4")]), _vm._v("—Hegel clearly distinguishes will ("), _c('i', [_vm._v("der Wille")]), _vm._v(") from free choice ("), _c('i', [_vm._v("die Willkür")]), _vm._v("): free choice, as the power to choose between possibilities, is only an aspect or moment—a moment of extreme tension"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn93",
      "id": "fn93r"
    }
  }, [_vm._v("5")]), _vm._v("—of the will, which is a force of "), _c('i', [_vm._v("rational")]), _vm._v(" self-determination. Second, Hegel is consistent in his rejection of the usual definition (which is also Kant’s) of law as a "), _c('i', [_vm._v("limitation")]), _vm._v(" of the will or free choice of each individual according to a universal rule. Indeed, that definition makes the will or free choice of the particular individual the primary principle of law rather than the “rational will which has being in and for itself,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn94",
      "id": "fn94r"
    }
  }, [_vm._v("6")]), _vm._v(" and thus it entails an irremediable deficit of universality. Finally, we must insist on the originality of the Hegelian definition of "), _c('i', [_vm._v("freedom")]), _vm._v(": understood in general as “being at home with oneself in the other,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn95",
      "id": "fn95r"
    }
  }, [_vm._v("7")]), _vm._v(" it can in no case be understood as the predicate of an isolated subjectivity, closed in on itself; it is rather a movement of objectification by an interiority that does not preexist this movement but constitutes itself thanks to it. Not only is freedom not the opposite of necessity, but the former necessarily passes through the latter, and in it, freedom “acquires the "), _c('i', [_vm._v("form of Necessity")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn96",
      "id": "fn96r"
    }
  }, [_vm._v("8")]), _vm._v(" A notion such as that of “objective will,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn97",
      "id": "fn97r"
    }
  }, [_vm._v("9")]), _vm._v(" used to introduce the concept of objective spirit or law in the broad sense, illustrates the shifts that the Hegelian definition of law presupposes.")]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0101"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p5"
    }
  }), _vm._v("The Strata of Willing")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The distinction between understanding (or reason) and will plays a constitutive role in modern philosophy, at least its dominant strand. As Descartes, who did not invent the distinction but did give it decisive significance, says,")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("All the modes of thinking that we experience within ourselves can be brought under two general headings: perception, or the operation of the intellect, and volition, or the operation of the will."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn98",
      "id": "fn98r"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Of course, Kant complicated the schema by distinguishing between understanding and reason and by adding a third term, the faculty of judgment, to the “powers of the mind.” But knowing and willing, thinking and wanting are still the two fundamental powers of the mind. The will, explains Kant, is “a power [of all rational beings] to determine their causality by the presentation of rules,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn99",
      "id": "fn99r"
    }
  }, [_vm._v("11")]), _vm._v(" and one cannot conceive of reason determining the will (that is to say, of reason being “practical in-itself”) unless one has an adequate concept of the freedom of the will—in this case, the concept of autonomy, “the sole principle of all moral laws.”")]), _vm._v(" "), _c('p', [_vm._v("Hegel rejects this dualism between theory and practice, between knowledge and will, and he thus sets “practical philosophy” (which in his work no longer goes by that name) on a new path. In both the "), _c('i', [_vm._v("Logic")]), _vm._v(" (the penultimate chapter of which deals with “the idea of cognition”) and in the "), _c('i', [_vm._v("Encyclopedia")]), _vm._v("’s theory of subjective spirit, Hegel insists on the fundamental continuity—a continuity, it is true, that is less linear than circular, and less consecutive than dialectical—between thinking and willing, between theory and practice. Thus, we read in an Addition in the "), _c('i', [_vm._v("Encyclopedia")]), _vm._v(",")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("For ordinary thinking, thought and will fall outside of each other. But in truth . . . thought determines itself into will and remains the substance of the latter; so that without thought there can be no will."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn100",
      "id": "fn100r"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p6"
    }
  }), _vm._v("Two aspects of this continuity should be emphasized. First, practical spirit (the will) is less the complement or competitor of theoretical spirit than the result of theoretical spirit going deeper within itself: thinking intelligence takes complete ownership of the object it believed it would merely find and meet as a given and posits itself as the reason that produces this objectivity (and thus is practical):")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("But when intelligence is aware that it is determinative of the content, which is "), _c('i', [_vm._v("its")]), _vm._v(" mode no less than it is a mode of being, it is Will."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn101",
      "id": "fn101r"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Second, the will is not solely the outcome of theoretical spirit or intelligence. The will itself, at least from the philosopher’s point of view, includes a dynamism that tends to reproduce in it the element from which it results (thinking, the intellectual act). With what the third edition of the "), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" calls “free spirit,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn102",
      "id": "fn102r"
    }
  }, [_vm._v("14")]), _vm._v(" there is, at the transition point between subjective spirit and objective spirit—thus, at the point of contact between the finite subject and the juridical and ethical-political objectivity of a common world—a resurgence of knowledge within the will in the form of the "), _c('i', [_vm._v("universal")]), _vm._v(":")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Actual free will is the unity of theoretical and practical spirit: a free will, which realizes its own freedom of will. . . . This universalism, the will has as its object and aim, only so far as it thinks itself, knows this [as] its concept, and is "), _c('i', [_vm._v("will")]), _vm._v(" as free "), _c('i', [_vm._v("intelligence")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn103",
      "id": "fn103r"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', [_vm._v("Let us not be fooled into thinking that this is an empty dialectical game. To the contrary, we must convince ourselves that the reciprocal implication and copenetration of knowing and willing are essential to the project of a “philosophy of spirit”—an expression, we must remember, created by Hegel, as was the doublet "), _c('i', [_vm._v("Naturwissenschaften-Geisteswissenschaften")]), _vm._v(". In brief, this project aspires"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p7"
    }
  }), _vm._v(" to make objective spirit ("), _c('i', [_vm._v("objectivity")]), _vm._v(" in law, morality, and ethical-political institutions)—that is, this “"), _c('i', [_vm._v("world")]), _vm._v(" produced and to be produced by”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn104",
      "id": "fn104r"
    }
  }, [_vm._v("16")]), _vm._v(" spirit—appear as the outcome, or rather as the always necessary presupposition of subjectivity (in the ordinary sense of the term). In other words, the reciprocal implication of the theoretical and the practical, of knowing and willing (which are here anything but “faculties” of an empirical or transcendental subject), is what allows Hegel to develop a nonsubjective concept of spirit, which includes an objective moment that is just as necessary as its subjective moment. And only such a concept—which in reality is only consistent insofar as, beyond these two finite moments, it fits into the infinite processual totality of "), _c('i', [_vm._v("absolute spirit")]), _vm._v("—makes it possible to give meaning to the following statement, which disrupts the idea we have of both spirit and knowledge:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("If to be aware of the Idea . . . is a matter of "), _c('i', [_vm._v("speculation")]), _vm._v(", still this very Idea itself is the actuality of men—not something which they "), _c('i', [_vm._v("have")]), _vm._v(", as men, but which they "), _c('i', [_vm._v("are")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn105",
      "id": "fn105r"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("However, although the Hegelian doctrine of will excludes the usual dichotomy between knowing and willing, theoretical and practical, it also endeavors to "), _c('i', [_vm._v("integrate")]), _vm._v(" the various classical conceptions of will by relativizing them and making them into moments, partial and, as such, nonindependent aspects of a "), _c('i', [_vm._v("unified")]), _vm._v(" and speculative concept of will. This concept is itself considered under the aforementioned conception—perhaps the guiding idea of Hegelian philosophy—of freedom as "), _c('i', [_vm._v("Beisichsein im Anderen")]), _vm._v(", as being at home with oneself in and thanks to what is other than oneself or through alienation from oneself. It is appropriate here to mention quickly the stratification of the concept of the will as it is presented in detail (more so than in the "), _c('i', [_vm._v("Encyclopedia")]), _vm._v(") in paragraphs 5 to 28 of the introduction to the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v("."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn106",
      "id": "fn106r"
    }
  }, [_vm._v("18")]), _vm._v(" Indeed, this stratification is what accounts for the necessity of the objectivization of the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p8"
    }
  }), _vm._v("will—in other words, the transition from subjective spirit to what Hegel calls objective spirit.")]), _vm._v(" "), _c('p', [_vm._v("The text first presents (§§ 5–10) what we may call the determinants of the process of the will. These consist of the three moments—the universal, the particular, and the individual—of the not-yet-developed concept of the will (§§ 5–8) as well as the principles of the differentiation or particularization of “abstract” or “formal” will, which “"), _c('i', [_vm._v("finds")]), _vm._v(" an external world outside itself” (§§ 8–10):"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn107",
      "id": "fn107r"
    }
  }, [_vm._v("19")]), _vm._v(" an active relation to the given that is the world and the (necessary) determination that consists in giving this abstract will a content or purpose, which is a matter of “translat[ion] . . . into objectivity.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn108",
      "id": "fn108r"
    }
  }, [_vm._v("20")]), _vm._v(" In a second phase, which corresponds to the bulk of the passage, Hegel studies in succession the three figures the will takes when it leaves abstraction. These are less separate forms of the will than integrative moments whose dynamic totalization alone gives access to the fully developed idea of the will: “the "), _c('i', [_vm._v("immediate")]), _vm._v(" or "), _c('i', [_vm._v("natural")]), _vm._v(" will” (§§ 11–13); free choice ("), _c('i', [_vm._v("Willkür")]), _vm._v("), “the commonest idea ["), _c('i', [_vm._v("Vorstellung")]), _vm._v("] we have of freedom,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn109",
      "id": "fn109r"
    }
  }, [_vm._v("21")]), _vm._v(" which is analyzed in its constitutive “contradiction” or in the dialectical tension that sets it against drives, desires, and passions (§§14–20); and finally, the “will which is free in and "), _c('i', [_vm._v("for itself")]), _vm._v(",” which is “truly infinite” (§ 22, p. 54) and which, as actual infinity ("), _c('i', [_vm._v("infinitum actu")]), _vm._v("), is universal and objective as well as subjective (§§ 21–28).")]), _vm._v(" "), _c('p', [_vm._v("Without going into a detailed examination of this difficult passage, which attests to the innovativeness of the Hegelian conceptualization of the will, it must be emphasized that the passage clearly aims to "), _c('i', [_vm._v("integrate")]), _vm._v(" the various competing conceptions of freedom into a concept that can house all of them but that can also relativize them by highlighting what is unilateral in them: the concept of a freedom that has only itself as object (the “free will which wills the free will,” says § 27) and not out of autism but because it finds itself in its object and only in this way can it access its identity, which is inseparably both subjective and objective. There can only be a willing subject insofar as that subject seeks to gain its own subjectivity in things and knows that only in this way can it constitute its subjectivity:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p9"
    }
  }), _vm._v("The activity of the will consists in cancelling ["), _c('i', [_vm._v("aufheben")]), _vm._v("] the contradiction between subjectivity and objectivity and in translating its ends from their subjective determination into an objective one, while at the same time remaining "), _c('i', [_vm._v("with itself")]), _vm._v(" in this objectivity. . . . This activity is the "), _c('i', [_vm._v("essential development")]), _vm._v(" of the substantial content of the Idea, a development in which the concept determines the "), _c('i', [_vm._v("Idea")]), _vm._v(", which is "), _c('i', [_vm._v("itself")]), _vm._v(" at first "), _c('i', [_vm._v("abstract")]), _vm._v(" to [produce] the totality of its system. This totality, as the substantial element, is independent of the opposition between a merely subjective end and its realization, and is "), _c('i', [_vm._v("the same")]), _vm._v(" in both of these forms."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn110",
      "id": "fn110r"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Let us retain from this brief analysis that one does not really "), _c('i', [_vm._v("think")]), _vm._v(" the will, in the complexity of its being and manifestations, when it is reduced to one of its "), _c('i', [_vm._v("moments")]), _vm._v(", given that in Hegel a moment is always a nonindependent aspect of a totality. The will cannot be identified with either the natural will, which is immediate and finite and exhausts itself in a singular, prejudgmental decision that takes into consideration one or another of our contradictory affects, or with free choice ("), _c('i', [_vm._v("Willkür")]), _vm._v("), the reflexive power to make a deliberate choice between the abstract possibilities represented by one’s drives and desires, or even with the will that is free in and for itself, taken in isolation (which nevertheless wills itself "), _c('i', [_vm._v("objectively")]), _vm._v(" in the world of objectivity that it encounters and inhabits). So what, then, is the will? Nothing other than the dynamic "), _c('i', [_vm._v("system")]), _vm._v(" of these different moments, which can be identified within common representations and which certain philosophies (it is not difficult to put names to the descriptions Hegel gives) have taken unilaterally to be the entirety of the will. The Hegelian concept of the will is not the concept of a thing or the concept of a faculty that would be a thing (“the soul”) that produces certain effects. It designates, rather, a process inseparable from the process of thought, which links together and relativizes the partial meanings that can be attributed to this process and which carries as if to its conclusion the idea of an "), _c('i', [_vm._v("objectivization")]), _vm._v(" of the will—an objectivization that is less the effect of action by subjectivity than the apparently given presupposition of action: the “way of the will” consists in “mak[ing] itself objective spirit.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn111",
      "id": "fn111r"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ah0102"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p10"
    }
  }), _vm._v("Objectivization: Law")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("From the beginning, what distinguishes practical spirit and theoretical spirit, will and intelligence, is that the latter presupposes its object (the world to be known, which it takes in or seems to take in as a given), whereas the will, as Kant indicates, is the power to “produce objects corresponding to one’s presentations”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn112",
      "id": "fn112r"
    }
  }, [_vm._v("24")]), _vm._v(": it engenders its objects, which are neither things nor ideas but actions, or rather schemata of actions, that include a normative claim. It is thus normal that the development of practical spirit, whose different strata I have just presented (and which are all moments of a dynamic conception of willing), should culminate in an objectivization of initially (apparently) merely subjective will. In reality, it will appear that, in keeping with the progressive-regressive structure of the Hegelian method,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn113",
      "id": "fn113r"
    }
  }, [_vm._v("25")]), _vm._v(" this objectivization of the will in legal, social, and political norms and institutions is "), _c('i', [_vm._v("presupposed")]), _vm._v(" by the constitution of subjective will while this subjective will at the same time "), _c('i', [_vm._v("posits")]), _vm._v(", from itself, the necessity of this objectivization. Finite subjectivity (which is finite precisely because it is "), _c('i', [_vm._v("only")]), _vm._v(" subjective), in going to its limit, is led to find or recognize itself in the “actuality of a world,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn114",
      "id": "fn114r"
    }
  }, [_vm._v("26")]), _vm._v(" in which it encounters the ends it posits as its own, in the objective form of institutionalized norms.")]), _vm._v(" "), _c('p', [_vm._v("This is carefully presented in Hegel’s development of the idea of the good in the penultimate chapter of the "), _c('i', [_vm._v("Logic")]), _vm._v(". The paradox or contradiction—but we must remember that “the thought of contradiction is the essential moment of the concept”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn115",
      "id": "fn115r"
    }
  }, [_vm._v("27")]), _vm._v("—of what Hegel calls the syllogism of action is that action supposes both (1) that the purpose it prescribes for itself has not been realized (otherwise there would be no need to act) and (2) that in a certain way it is always already realized in the sense that the world is in some way disposed to receive the purposes of the acting subject (otherwise action would always shatter against the resistance of the world). But this contradiction must be thought in its productive dynamic: to grasp its fecundity, one needs merely "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p11"
    }
  }), _vm._v("to bring together the two premises of the syllogism and to accept (this is the paradox inherent to all acting and all willing) that “the "), _c('i', [_vm._v("purpose of")]), _vm._v(" ["), _c('i', [_vm._v("the action")]), _vm._v("] is being achieved and equally is not being achieved.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn116",
      "id": "fn116r"
    }
  }, [_vm._v("28")]), _vm._v(" Hegel specifies this idea in his lectures and shows how it implies overcoming Kantian and Fichtean normativism:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("The good ought to be realised; we have to work at this, to bring it forth, and the will is simply the good that is self-activating. But then if the world were as it ought to be, the result would be that the activity of willing would disappear. Therefore the will itself also requires that its purpose shall not be realised. This correctly expresses the finitude of willing. . . . The will knows the purpose as what is its own, and intelligence interprets the world as the Concept in its actuality. This is the genuine position of rational cognition.")]), _vm._v(" "), _c('p', {
    staticClass: "bql"
  }, [_vm._v("What is null and vanishing constitutes only the surface of the world, not its genuine essence. This essence is the Concept that is in and for itself, and so the world is itself the Idea. Unsatisfied striving vanishes when we [re]cognise that the final purpose of the world is just as much accomplished as it is eternally accomplishing itself."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn117",
      "id": "fn117r"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The transition from subjective spirit to objective spirit (from will to law and rights) corresponds to the discovery that individual subjectivity and universal objectivity are in a way preordained for one another. But it should be added, as Hegel immediately does, that “this agreement between is and ought is not rigid and unmoving, however, since the final purpose of the world, the good, only "), _c('i', [_vm._v("is")]), _vm._v(", because it constantly brings itself about.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn118",
      "id": "fn118r"
    }
  }, [_vm._v("30")]), _vm._v(" Contrary to a commonly raised suspicion, the concept of objective spirit does not imply any quietism, any “benediction of what exists” (Rudolf Haym); it does not mean that all good purposes are always already realized, and even less that the good is always already accomplished in a world eternally identical to what it must be. Far from subscribing to such a conservative metaphysics, Hegel considers that action, always necessary, always urgent, must reside in the space of play that separates and binds an unbridled subjectivity, supremely ignorant of the “right of the world,” and an objectivity that is illusorily believed to be closed "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p12"
    }
  }), _vm._v("in on itself, autotelic. The world of objective spirit is, however, neither soft wax nor impenetrable granite; this is what is established by the analysis of "), _c('i', [_vm._v("Sittlichkeit")]), _vm._v(" in its twofold subjective and objective dimension."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn119",
      "id": "fn119r"
    }
  }, [_vm._v("31")]), _vm._v(" The world is disposed to receive the effort that is always demanded of subjectivity while at the same time it constantly reminds subjectivity of the conditions of objectivity of its acting. Thus, actual will can only exist within a world open even to the will’s most anarchical expressions because they are secretly congruent with it.")]), _vm._v(" "), _c('p', [_vm._v("Why then does Hegel assign the name "), _c('i', [_vm._v("law")]), _vm._v(" to segments of objective spirit, giving this term a meaning that deliberately goes beyond its legal usage? This metonymical function of law has something to do with the "), _c('i', [_vm._v("institutionalism")]), _vm._v(" of the Hegelian doctrine of objective sprit."), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn120",
      "id": "fn120r"
    }
  }, [_vm._v("32")]), _vm._v(" The legal order, even reduced to abstract law alone (the private law of jurists, or at least its rational substructure), is in a way the paradigm of an "), _c('i', [_vm._v("institutional system")]), _vm._v(": it is a set of universal and objective determinations that, escaping the grasp of actors (law is unavailable to them) nevertheless appears as that which can provide a meaning, or at least a description, to their acts. In other words, it is because Hegel thinks that abstract law founds an “objective individuality” and institutes “rights without subjects”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn121",
      "id": "fn121r"
    }
  }, [_vm._v("33")]), _vm._v(" that he can make it a "), _c('i', [_vm._v("blueprint")]), _vm._v(" for objective freedom. It is true that only ethical institutions (familial, social, and political institutions) form “developed and actualized rationality.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn122",
      "id": "fn122r"
    }
  }, [_vm._v("34")]), _vm._v(" But this ethical “second nature,” this set of institutional configurations that the “political disposition”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn123",
      "id": "fn123r"
    }
  }, [_vm._v("35")]), _vm._v(" of individuals invigorates and structures, does nothing more than carry out and realize the formal structure defined by abstract law: the institutional conversion of subjectivity into "), _c('i', [_vm._v("personality")]), _vm._v(", the indefinite thing into a legally classified thing, in which “I, as free will, am an object ["), _c('i', [_vm._v("gegenständlich")]), _vm._v("] for myself.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn124",
      "id": "fn124r"
    }
  }, [_vm._v("36")]), _vm._v(" In short, the objectification of freedom, the sole motive for the entire doctrine of objective "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "p13"
    }
  }), _vm._v("spirit, finds its fundamental organization in law in the narrow sense, in the “abstract law” of jurists.")]), _vm._v(" "), _c('p', [_vm._v("One of the main reasons for the exemplary value accorded to abstract law is its promotion of a “subjectless” concept of the will. Hegel—and I am aware that here I am going against the still-dominant opinion according to which he is mistaken about the intellectual construction of law"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn125",
      "id": "fn125r"
    }
  }, [_vm._v("37")]), _vm._v("—bases himself on what can be called an immanent philosophy of the formal legal order all in order to contest the "), _c('i', [_vm._v("subjectivist")]), _vm._v(" understanding of the concept of the will dominant among philosophers. When Hegel talks about “objective will,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn126",
      "id": "fn126r"
    }
  }, [_vm._v("38")]), _vm._v(" when he talks about the reciprocal institution of persons and things, his argument outrages philosophers trained in the Kantian or Fichtean tradition. But his argument would be much less shocking to a jurist, who is used to defining, for example, property as the objectification of a will ("), _c('i', [_vm._v("animus")]), _vm._v(") through material indexes ("), _c('i', [_vm._v("corpus")]), _vm._v("). If, as an eminent historian maintains, “the Romans did not consider "), _c('i', [_vm._v("corpus")]), _vm._v(" and "), _c('i', [_vm._v("animus")]), _vm._v(" as two independent established facts, one objective, the other subjective, but rather grasped two sides of a process represented as one unit,”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn127",
      "id": "fn127r"
    }
  }, [_vm._v("39")]), _vm._v(" then we can agree that the Hegelian conception of objective spirit (of law in the broad sense), like the objectification of will, is in general terms in accord with Roman law (of which it is at most an extrapolation—and this also obviously does not mean that Hegel subscribes to the dominant interpretation of the Roman theory of property law, which was put forward in 1803 by Savigny in "), _c('i', [_vm._v("Das Recht des Besitzes")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("To conclude, let us summarize what we have seen so far.")]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "none"
    }
  }, [_c('li', {
    staticClass: "nlf"
  }, [_vm._v("(1) The will cannot be conceived as a faculty of a subject, nor can an act of willing be conceived as a simple exercise of decision by this faculty; the "), _c('i', [_vm._v("objectification")]), _vm._v(" of the will must therefore be thought of as the necessary culmination of the dialectical deployment of its components. The will is only fully adequate to itself, is only a free will willing its own freedom, by investing things and being invested in things, which it first does "), _c('i', [_vm._v("qua")]), _vm._v(" legal will.")]), _vm._v(" "), _c('li', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p14"
    }
  }), _vm._v("(2) Thanks to the operators of person, property, and contract, abstract law is the paradigm of such an objectification of the will. It is entirely a system of institutional objectification of freedom, and this is why it can be regarded as a formal sketch of the sphere of objective spirit in its entirety.")]), _vm._v(" "), _c('li', {
    staticClass: "nll"
  }, [_vm._v("(3) But legal will is not only objective will: it is also, or tends to be, a universal and rational will. However, it only "), _c('i', [_vm._v("tends")]), _vm._v(" toward this, and this is what, for Hegel, marks the limit of the law in general and of objective spirit: it contains only “the "), _c('i', [_vm._v("existential")]), _vm._v(" side of reason.”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn128",
      "id": "fn128r"
    }
  }, [_vm._v("40")]), _vm._v(" If, as the preface to the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" indicates, there must be congruence between reason that thinks and reason that is,"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn129",
      "id": "fn129r"
    }
  }, [_vm._v("41")]), _vm._v(" then it seems that the sphere of objective reason has an impassable limit. Indeed, following the teaching of the "), _c('i', [_vm._v("Logic")]), _vm._v(", for Hegel, the reconciliation between objective rationality (law, ethics) and rational thought (philosophy) cannot take place in the field of objectivity. In other words, objective spirit (“law”) cannot develop the rationality inherent to it except by going beyond its limits both as law and as will. This limit is the limit that constitutes for objective spirit its objectivity, and going beyond it constitutes the transition from objective spirit to absolute spirit: “genuine objectivity,” Hegel writes, “is only in the medium of "), _c('i', [_vm._v("thought")]), _vm._v(".”"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chikervegan0009#fn130",
      "id": "fn130r"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('h2', {
    staticClass: "ah"
  }, [_vm._v("Footnotes")]), _vm._v(" "), _c('div', {
    staticClass: "notes"
  }, [_c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn89r",
      "id": "fn89"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('i', [_vm._v("W")]), _vm._v(", 12:524; "), _c('i', [_vm._v("Lectures on the Philosophy of World History")]), _vm._v(", 442.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn90r",
      "id": "fn90"
    }
  }, [_vm._v("2")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 29, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 45 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 58; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 46).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn91r",
      "id": "fn91"
    }
  }, [_vm._v("3")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 486, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, pp. 479–80 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 243).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn92r",
      "id": "fn92"
    }
  }, [_vm._v("4")]), _vm._v(". Kant, "), _c('i', [_vm._v("MdS")]), _vm._v(", Einleitung, "), _c('i', [_vm._v("AA")]), _vm._v(" VI, pp. 213, 226; "), _c('i', [_vm._v("Practical Philosophy")]), _vm._v(" ["), _c('i', [_vm._v("PP")]), _vm._v("], pp. 374, 380.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn93r",
      "id": "fn93"
    }
  }, [_vm._v("5")]), _vm._v(". “Instead of being the will in its truth, arbitrariness is rather the will as "), _c('i', [_vm._v("contradiction")]), _vm._v(".” "), _c('i', [_vm._v("RPh")]), _vm._v(", § 15 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 39 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 48; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 38). See "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 145 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 8, p. 285 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 206).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn94r",
      "id": "fn94"
    }
  }, [_vm._v("6")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 29 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 80 ("), _c('i', [_vm._v("Outlines")]), _vm._v(", 47, see "), _c('i', [_vm._v("Elements")]), _vm._v(", 58).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn95r",
      "id": "fn95"
    }
  }, [_vm._v("7")]), _vm._v(". The “thinking of necessity” (that is, freedom) “is its going-together with "), _c('i', [_vm._v("itself")]), _vm._v(" in the other” ("), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 159 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 176 ["), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 234]). “To be sure, necessity as such is not yet freedom; but freedom presupposes necessity and contains it sublated within itself” ("), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 158 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 8, p. 303 ["), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 233]).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn96r",
      "id": "fn96"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 484, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 478 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 241). The second edition of the "), _c('i', [_vm._v("Encyclopädie")]), _vm._v(" (1827 ["), _c('i', [_vm._v("Enzykl")]), _vm._v("]) says “realize its concept . . . in the externally objective realm” (§ 485, "), _c('i', [_vm._v("GW")]), _vm._v(" 19, p. 353). See also "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 385, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 383 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 20): “a "), _c('i', [_vm._v("world")]), _vm._v(" produced and to be produced by it [spirit].”")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn97r",
      "id": "fn97"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 486, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 480 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 242).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn98r",
      "id": "fn98"
    }
  }, [_vm._v("10")]), _vm._v(". René Descartes, "), _c('i', [_vm._v("The Principles of Philosophy")]), _vm._v(", I, art. 32, in René Descartes, "), _c('i', [_vm._v("The Philosophical Writings of Descartes")]), _vm._v(", trans. John Cottingham, Robert Stoothoff, Dugald Murdoch, and Anthony Kenny (Cambridge: Cambridge University Press, 1985), 1:204.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn99r",
      "id": "fn99"
    }
  }, [_vm._v("11")]), _vm._v(". Kant, "), _c('i', [_vm._v("KpV")]), _vm._v(", "), _c('i', [_vm._v("Ak.")]), _vm._v(" 5, p. 32.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn100r",
      "id": "fn100"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 468 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 10, p. 288 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 227–28). See also "), _c('i', [_vm._v("Enzykl")]), _vm._v(", §§ 443–44, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, pp. 437–39 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 227) and "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 177–78, 231–32 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 675, 728–30).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn101r",
      "id": "fn101"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 468, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 465 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 227).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn102r",
      "id": "fn102"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", §§ 481–82, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 476 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 238–40). These two paragraphs correspond, in the first edition, to the two first paragraphs of the section on objective spirit ("), _c('i', [_vm._v("Enzykl")]), _vm._v(" 1817, §§ 400–401, "), _c('i', [_vm._v("GW")]), _vm._v(" 13, p. 224 ["), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 1817, 201]).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn103r",
      "id": "fn103"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 481, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 476 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 238–39, modified).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn104r",
      "id": "fn104"
    }
  }, [_vm._v("16")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 385, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 383 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 20).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn105r",
      "id": "fn105"
    }
  }, [_vm._v("17")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 482 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 477 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 240).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn106r",
      "id": "fn106"
    }
  }, [_vm._v("18")]), _vm._v(". This passage ("), _c('i', [_vm._v("RPh")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 32–45; "), _c('i', [_vm._v("Elements")]), _vm._v(", 37–58; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 28–46) must be read in parallel with §§ 388–401 of the 1817 "), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" ("), _c('i', [_vm._v("Enzykl")]), _vm._v(" 1817, "), _c('i', [_vm._v("GW")]), _vm._v(" 13, p. 217–24 ["), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 1817, 235–41]) or with "), _c('i', [_vm._v("Enzykl")]), _vm._v(" §§ 469–82, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 466–77 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 228–41; or, in the second edition, "), _c('i', [_vm._v("GW")]), _vm._v(" 19, p. 344–52). A very detailed commentary on the introduction to the "), _c('i', [_vm._v("Philosophy of Right")]), _vm._v(" can be found in Adriaan Peperzak, “Zur Hegelschen Ethik,” in "), _c('i', [_vm._v("Hegels Philosophie des Rechts: Die Theorie der Rechtsformen und ihre Logik")]), _vm._v(", ed. Dieter Henrich and Rolf-Peter Horstmann (Stuttgart: Klett-Cotta, 1982).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn107r",
      "id": "fn107"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 8, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 35 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 42–43; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 33).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn108r",
      "id": "fn108"
    }
  }, [_vm._v("20")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 9, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 35 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 43; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 34).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn109r",
      "id": "fn109"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 15 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 38 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 48; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 37).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn110r",
      "id": "fn110"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 28, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 45 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 57–58; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 46).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn111r",
      "id": "fn111"
    }
  }, [_vm._v("23")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 469, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 466 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 228).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn112r",
      "id": "fn112"
    }
  }, [_vm._v("24")]), _vm._v(". Kant, "), _c('i', [_vm._v("KpV")]), _vm._v(", "), _c('i', [_vm._v("Ak.")]), _vm._v(" 5, p. 15.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn113r",
      "id": "fn113"
    }
  }, [_vm._v("25")]), _vm._v(". On this point, see the methodological considerations in the last chapter of the "), _c('i', [_vm._v("Science of Logic")]), _vm._v(". For example, “each step of the "), _c('i', [_vm._v("advance")]), _vm._v(" in the process of further determination, while getting away from the indeterminate beginning, is also a "), _c('i', [_vm._v("getting back closer")]), _vm._v(" to it” ("), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 251 ["), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 750]).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn114r",
      "id": "fn114"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 484, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 478 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 241).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn115r",
      "id": "fn115"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('i', [_vm._v("WdL")]), _vm._v(" 3, "), _c('i', [_vm._v("GW")]), _vm._v(" 12, p. 246 ("), _c('i', [_vm._v("Science of Logic")]), _vm._v(", 745).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn116r",
      "id": "fn116"
    }
  }, [_vm._v("28")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 234, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 227 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 301).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn117r",
      "id": "fn117"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 234 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 8, p. 387 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 302).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn118r",
      "id": "fn118"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 234 Zusatz, "), _c('i', [_vm._v("W")]), _vm._v(" 8, p. 387 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 302).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn119r",
      "id": "fn119"
    }
  }, [_vm._v("31")]), _vm._v(". “The identity—which is accordingly "), _c('i', [_vm._v("concrete")]), _vm._v("—of the good and the subjective will, the truth of them both, is "), _c('i', [_vm._v("ethicality. . . .")]), _vm._v(" The "), _c('i', [_vm._v("ethical")]), _vm._v(" is a subjective disposition, but of that law which has being in itself” ("), _c('i', [_vm._v("RPh")]), _vm._v(", § 141 and Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 135 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 185–86, modified; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 152).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn120r",
      "id": "fn120"
    }
  }, [_vm._v("32")]), _vm._v(". See below, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0023#pt04"
    }
  }, [_vm._v("part 4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0024#pt04pre"
    }
  }, [_vm._v("preliminary")]), _vm._v(", and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0027#ch12"
    }
  }, [_vm._v("chapter 12")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn121r",
      "id": "fn121"
    }
  }, [_vm._v("33")]), _vm._v(". These terms are taken from Maurice Hauriou, representative par excellence of legal institutionalism; see Maurice Hauriou, "), _c('i', [_vm._v("Principes du droit public")]), _vm._v(" (Paris: Sirey, 1916), 93 ff.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn122r",
      "id": "fn122"
    }
  }, [_vm._v("34")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 265, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 211 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 287; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 239).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn123r",
      "id": "fn123"
    }
  }, [_vm._v("35")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 268, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 211 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 288; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 240). See also "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chikervegan0026#ch11"
    }
  }, [_vm._v("chapter 11")]), _vm._v(", below.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn124r",
      "id": "fn124"
    }
  }, [_vm._v("36")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 45, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 57 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 76; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 61).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn125r",
      "id": "fn125"
    }
  }, [_vm._v("37")]), _vm._v(". This point of view is exemplified by Michel Villey, “Le droit romain dans la philosophie du droit de Hegel,” "), _c('i', [_vm._v("Archives de Philosophie du Droit")]), _vm._v(" 16 (1971).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn126r",
      "id": "fn126"
    }
  }, [_vm._v("38")]), _vm._v(". "), _c('i', [_vm._v("RPh")]), _vm._v(", § 13 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 37, and § 26, p. 44 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 47 and 55. See "), _c('i', [_vm._v("Outlines")]), _vm._v(", 36, 44).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn127r",
      "id": "fn127"
    }
  }, [_vm._v("39")]), _vm._v(". Max Kaser, "), _c('i', [_vm._v("Das römische Privatrecht")]), _vm._v(" (Munich: Beck, 1955), 1:331.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn128r",
      "id": "fn128"
    }
  }, [_vm._v("40")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 482, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 476 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 239).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn129r",
      "id": "fn129"
    }
  }, [_vm._v("41")]), _vm._v(". See "), _c('i', [_vm._v("RPh")]), _vm._v(", "), _c('i', [_vm._v("GW")]), _vm._v(" 14.1, p. 15 ("), _c('i', [_vm._v("Elements")]), _vm._v(", 21; see "), _c('i', [_vm._v("Outlines")]), _vm._v(", 15).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', {
    staticClass: "fn"
  }, [_c('a', {
    staticClass: "fnnum",
    attrs: {
      "href": "#/chikervegan0009#fn130r",
      "id": "fn130"
    }
  }, [_vm._v("42")]), _vm._v(". "), _c('i', [_vm._v("Enzykl")]), _vm._v(", § 562 Anmerkung, "), _c('i', [_vm._v("GW")]), _vm._v(" 20, p. 548 ("), _c('i', [_vm._v("Encyclopedia")]), _vm._v(" 297).")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c79208e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kervegan-0009.vue
// module id = 78
// module chunks = 0